class BaseAPI {
    constructor(token){
        this.token = token;
    }
}

export default BaseAPI;